































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { InputResponse } from '@/constants/form/types'

@Component({})
export default class Input extends Vue {
  /**要素タイプ */
  @Prop({ default: 'text' })
  private type?: string;
  /** 入力要素名 */
  @Prop({ default: '' })
  private name!: string;
  /** 入力要素ラベルのテキスト */
  @Prop({ default: '項目' })
  private labelText?: string;
  /** テキストフィールドの初期値 */
  @Prop({ default: '' })
  private value?: string;
  /** テキストフィールドのプレースホルダ */
  @Prop({ default: '' })
  private placeholder?: string;
  /** テキストフィールドに入力できる最大文字数 */
  @Prop({ default: '' })
  private maxlength?: string;
  /** テキストフィールドの非活性設定 */
  @Prop({ default: false })
  private isDisabled?: boolean;
  /** テキストフィールドの読み取り専用設定 */
  @Prop({ default: false })
  private isReadOnly?: boolean;
  /** テキストフィールド内後方にセットされるアイコンv */
  @Prop({ default: '' })
  private appendIcon?: string;
  /** コンポーネントの先頭にセットされるアイコン */
  @Prop({ default: '' })
  private prependIcon?: string;
  /** テキストフィールド内前方にセットされるアイコン */
  @Prop({ default: '' })
  private prependInnerIcon?: string;
  /** バリデーションルール */
  @Prop({ default: '' })
  private rules?: string;
  /* 数値項目を3桁カンマ区切りで表現する設定 */
  @Prop({ default: false })
  private isCommaNumber?: boolean;
  
  public innerType = 'text';
  public inputVal = '';
  public errMessage = '';
  public isOnFocus = false;

  mounted() {
    if (this.type) {
      this.innerType = this.type;
    }
    if (this.value) {
      if (this.isCommaNumber) {
        // カンマを設定するため、強制的にtypeをtextに変更する
        this.innerType = 'text';
        this.inputVal = Number(this.value).toLocaleString();
      } else {
        this.inputVal = this.value;
      }
    }
  }

  onBlur() {
    this.isOnFocus = false;
    if (this.isCommaNumber && !this.isReadOnly) {
      // フォーカスアウトした場合、カンマ区切りで表示するために設定を変更する
      this.innerType = 'text';
      this.inputVal = Number(this.inputVal).toLocaleString();
    }
  }

  onFocus() {
    this.isOnFocus = true;
    if (this.isCommaNumber && !this.isReadOnly) {
      // フォーカスがあたった場合、数値入力できるように設定を変更する
      this.inputVal = this.inputVal.replaceAll(',', '');
      this.innerType = 'number';
    }
  }

  @Watch('value')
  watchValue() {
    if (this.isCommaNumber) {
      // カンマ区切りで表示するために設定を変更する
      // ただし、フォーカスが当たっているときは無視する
      if (this.isOnFocus) return;
      this.innerType = 'text';
      this.inputVal = this.value ? Number(this.value).toLocaleString() : '';
    } else {
      this.inputVal = this.value ? this.value : '';
    }
  }

  // TODO: 算出プロパティとして使っていないのであれば削除してよいはず
  private get inputValue(): string {
    return this.inputVal;
  }

  // TODO: 算出プロパティとして使っていないのであれば削除してよいはず
  private set inputValue(inputVal: string) {
    this.inputVal = inputVal;
  }

  /**
   * 親コンポーネントに入力値を通知する
   * @module inputOpratipon
   * @return InputResponse - 名前と入力値
   */
  @Emit('inputOpratipon')
  public inputOpratipon(): InputResponse {
    return {
      name: this.name,
      value: (this.isCommaNumber ? this.inputVal.replaceAll(',', '') : this.inputVal)
    };
  }
}
